import { Component, OnInit } from '@angular/core';
import { PacienteService } from 'src/app/services/paciente.service';

@Component({
  selector: 'app-menu-escalas',
  templateUrl: './menu-escalas.component.html',
  styles: []
})
export class MenuEscalasComponent implements OnInit {

  constructor(
    public _pacienteSrv: PacienteService,
  ) { }

  ngOnInit() {
  }

}
